import React from "react";
import colors from "../../styles/colors";
import greekHoofdstukken from "../../data/hoofdstukken-grieks";
import latinHoofdstukken from "../../data/hoofdstukken-latijn";
import greekLeerdoelen from "../../data/leerdoelen-grieks";
import latinLeerdoelen from "../../data/leerdoelen-latijn";
import Link from "gatsby-link";
import styled from "styled-components";

const Container = styled.div`
  margin-bottom: 2em;

  table {
    color: ${colors.main};
    font-size: 0.9em;
    font-weight: 400;
    letter-spacing: 0px;
    list-style: none;
    margin-bottom: -0.55em;
    margin-left: -0.15em;
    padding: 0 !important;
    text-transform: none;

    & + h2 {
      margin-top: 2em;
    }
  }

  td {
    line-height: 1.3em;
    padding-bottom: 0.4em;
    padding-right: 0.35em;
    vertical-align: top;
  }
`;

export default ({ book, chapter, leerdoel, type }) => {
  // where to get the leerdoelen/voorkennis per chapter from
  const hoofdstukken = book == "spqr" ? latinHoofdstukken : greekHoofdstukken;

  // where to get the formulation/voorkennis per leerdoel from
  const leerdoelen = book == "spqr" ? latinLeerdoelen : greekLeerdoelen;

  // what specific leerdoel codes to render
  const codes =
    type == undefined
      ? leerdoelen[leerdoel]["voorkennis"]
      : hoofdstukken[chapter - 1][type];

  // what h2 to render
  const heading = type => {
    switch (type) {
      case "leerdoelen":
        return "wat moet ik nu kunnen?";
      case "voorkennis":
        return "wat moet ik kunnen voordat ik begin?";
      default:
        return "voorkennis";
    }
  };

  const leerdoelDesc = code => leerdoelen[code].description;

  return (
    <div>
      {codes.length < 1 ? null : (
        <Container>
          <h2>{heading(type)}</h2>
          <table>
            <tbody>
              {codes.map(code => (
                <tr key={code}>
                  <td>{`${code}. `}</td>
                  {leerdoelen[code].pageExists ? (
                    <td>
                      <Link to={`/${book}/leerdoelen/${code}`}>
                        {leerdoelDesc(code)}
                      </Link>
                    </td>
                  ) : (
                    <td>{leerdoelDesc(code)}</td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </Container>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/grammatica/Leerdoelen.js